export const transformFileToGB = (fileSize: string | number): string => {
  const kbSize = Number(fileSize);

  if (isNaN(kbSize) || kbSize < 0) {
    throw new Error('Invalid file size. Expected a non-negative number or numeric string.');
  }

  const gbSize = kbSize / (1024 * 1024); // КБ → ГБ

  const formatSize = (size: number): string => {
    return size % 1 === 0 ? String(size) : size.toFixed(2).replace(/\.?0+$/, '');
  };

  if (gbSize >= 1024) {
    const tbSize = gbSize / 1024;
    return `${formatSize(tbSize)} ТБ`;
  } else {
    return `${formatSize(gbSize)} ГБ`;
  }
};